// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#333","menuActiveText":"#409EFF","subMenuActiveText":"#333","menuBg":"#fff","menuHover":"#e1e3e5","subMenuBg":"#fefefe","subMenuHover":"#e1e3e5","sideBarWidth":"210px"};